import React from 'react';
import cn from 'classnames';

import styles from './Receipt.module.css';

const Receipt = ({ animate }) => (
  <svg
    className={cn({ [`${styles.animate}`]: animate })}
    style={{ width: '100%', height: 'auto' }}
    viewBox="0 0 172 300"
  >
    <path
      d="M166.128 0L163.612 2.51892L161.093 0L158.578 2.51892L156.059 0L153.544 2.51892L151.025 0L148.51 2.51892L145.991 0L143.476 2.51892L140.957 0L138.442 2.51892L135.923 0L133.407 2.51892L130.888 0L128.373 2.51892L125.854 0L123.339 2.51892L120.82 0L118.305 2.51892L115.786 0L113.271 2.51892L110.752 0L108.233 2.51892L105.718 0L103.202 2.51892L100.683 0L98.1645 2.51892L95.6492 0L93.134 2.51892L90.6151 0L88.0962 2.51892L85.5809 0L83.0657 2.51892L80.5467 0L78.0278 2.51892L75.5126 0L72.9973 2.51892L70.4784 0L67.9595 2.51892L65.4442 0L62.929 2.51892L60.4101 0L57.8911 2.51892L55.3759 0L52.8606 2.51892L50.3417 0L47.8228 2.51892L45.3075 0L42.7923 2.51892L40.2734 0L37.7545 2.51892L35.2392 0L32.7239 2.51892L30.205 0L27.6861 2.51892L25.1709 0L22.6556 2.51892L20.1367 0L17.6178 2.51892L15.1025 0L12.5873 2.51892L10.0683 0L7.54943 2.51892L5.03417 0L2.51892 2.51892L0 0V300L2.51892 297.481L5.03417 300L7.54943 297.481L10.0683 300L12.5873 297.481L15.1025 300L17.6178 297.481L20.1367 300L22.6556 297.481L25.1709 300L27.6861 297.481L30.205 300L32.7239 297.481L35.2392 300L37.7545 297.481L40.2734 300L42.7923 297.481L45.3075 300L47.8228 297.481L50.3417 300L52.8606 297.481L55.3759 300L57.8911 297.481L60.4101 300L62.929 297.481L65.4442 300L67.9595 297.481L70.4784 300L72.9973 297.481L75.5126 300L78.0278 297.481L80.5467 300L83.0657 297.481L85.5809 300L88.0962 297.481L90.6151 300L93.134 297.481L95.6492 300L98.1645 297.481L100.683 300L103.202 297.481L105.718 300L108.233 297.481L110.752 300L113.271 297.481L115.786 300L118.305 297.481L120.82 300L123.339 297.481L125.854 300L128.373 297.481L130.888 300L133.407 297.481L135.923 300L138.442 297.481L140.957 300L143.476 297.481L145.991 300L148.51 297.481L151.025 300L153.544 297.481L156.059 300L158.578 297.481L161.093 300L163.612 297.481L166.128 300L168.647 297.481L171.162 300V0L168.647 2.51892L166.128 0Z"
      fill="white"
    />
    <path
      d="M52.2382 30.9116V31.7244H49.7852V26.0202H52.2382V26.8367H53.0547V28.4769H52.2382V29.2751H53.0547V30.9116H52.2382ZM52.2236 26.8477H50.6126V28.4586H52.2236V26.8477ZM52.2236 29.2861H50.6126V30.8933H52.2236V29.2861Z"
      fill="black"
    />
    <path
      d="M55.4784 31.7244V30.9116H54.6656V28.4623H55.4784V27.6458H57.1186V28.4623H57.935V30.1025H55.493V30.897H57.935V31.7244H55.4784V31.7244ZM57.1039 28.4769H55.493V29.2751H57.1039V28.4769Z"
      fill="black"
    />
    <path
      d="M61.1716 31.7244V30.9116H60.3552V28.4769H59.5424V27.6458H60.3552V26.0202H61.1863V27.6458H62.8118V28.4769H61.1863V30.897H62.8118V31.7244H61.1716Z"
      fill="black"
    />
    <path
      d="M66.0557 31.7244V30.9116H65.2392V28.4769H64.4264V27.6458H65.2392V26.0202H66.0703V27.6458H67.6959V28.4769H66.0703V30.897H67.6959V31.7244H66.0557Z"
      fill="black"
    />
    <path
      d="M70.1196 31.7244V30.9116H69.3068V28.4623H70.1196V27.6458H71.7598V28.4623H72.5763V30.1025H70.1343V30.897H72.5763V31.7244H70.1196V31.7244ZM71.7452 28.4769H70.1343V29.2751H71.7452V28.4769Z"
      fill="black"
    />
    <path
      d="M75.8274 28.4769V29.2897H75.0109V31.7244H74.1835V27.6458H75.0109V28.4623H75.8127V27.6458H77.453V28.4769H75.8274Z"
      fill="black"
    />
    <path
      d="M86.3864 31.7244V29.2897H84.7755V31.7244H83.9481V26.0202H84.7755V28.4623H86.3864V26.0202H87.2175V31.7244H86.3864V31.7244Z"
      fill="black"
    />
    <path
      d="M89.6412 31.7244V30.9117H88.8284V30.0842H89.6412V29.2678H91.2667V28.4733H89.6412V27.6422H91.2814V28.4586H92.0978V31.7208H89.6412V31.7244ZM91.2667 30.0989H89.6558V30.897H91.2667V30.0989Z"
      fill="black"
    />
    <path
      d="M93.7088 31.7244V30.897H94.5216V26.8477H93.7088V26.0166H95.349V30.8933H96.1618V31.7208H93.7088V31.7244Z"
      fill="black"
    />
    <path
      d="M100.229 28.4769V31.7244H99.3983V28.4769H98.5855V27.6458H99.3983V26.8367H100.215V26.0202H101.855V26.8513H100.229V27.6495H101.855V28.4806H100.229V28.4769Z"
      fill="black"
    />
    <path
      d="M110.803 30.9116V31.7244H108.35V26.0202H110.803V26.8367H111.619V28.4769H110.803V29.2751H111.619V30.9116H110.803ZM110.788 26.8477H109.177V28.4586H110.788V26.8477ZM110.788 29.2861H109.177V30.8933H110.788V29.2861Z"
      fill="black"
    />
    <path
      d="M114.043 31.7244V30.9117H113.23V30.0842H114.043V29.2678H115.669V28.4733H114.043V27.6422H115.683V28.4586H116.5V31.7208H114.043V31.7244ZM115.669 30.0989H114.058V30.897H115.669V30.0989Z"
      fill="black"
    />
    <path
      d="M119.751 28.4769V29.2897H118.935V31.7244H118.107V27.6458H118.935V28.4623H119.736V27.6458H121.377V28.4769H119.751Z"
      fill="black"
    />
    <path
      d="M49.7999 44.7474V46.3657H48.9724V44.7474H46.5341V43.1072H47.3468V42.2907H48.1596V41.4633H48.9761V40.6615H49.8035V43.9163H50.62V44.7474H49.7999V44.7474ZM48.1706 42.2907V43.1218H47.3578V43.92H48.9688V42.2944H48.1706V42.2907Z"
      fill="black"
    />
    <path
      d="M54.6803 45.5565V46.3693H53.04V45.5565H52.2272V41.4816H53.04V40.6651H54.6803V41.4816H55.4967V45.5565H54.6803V45.5565ZM54.6656 41.4926H53.0547V42.2907H53.8711V43.1072H54.6693V41.4926H54.6656ZM54.6656 43.9309H53.8528V43.1181H53.051V45.5382H54.6619V43.9309H54.6656Z"
      fill="black"
    />
    <path
      d="M59.5607 45.5565V46.3693H57.9204V45.5565H57.1076V41.4816H57.9204V40.6651H59.5607V41.4816H60.3771V42.309H59.546V41.4962H57.9351V43.1072H59.5607V43.92H60.3771V45.5565H59.5607ZM59.546 43.9309H57.9351V45.5382H59.546V43.9309Z"
      fill="black"
    />
    <path
      d="M69.3214 43.9309V46.3693H68.494V43.9309H67.6922V46.3693H66.8648V43.9309H66.052V40.6651H66.8794V43.92H67.6775V42.2944H68.5086V43.92H69.3068V40.6651H70.1379V43.9309H69.3214Z"
      fill="black"
    />
    <path
      d="M72.558 46.3693V45.5565H71.7452V44.7291H72.558V43.9127H74.1836V43.1182H72.558V42.2871H74.1982V43.1035H75.0147V46.3657H72.558V46.3693ZM74.1873 44.7438H72.5763V45.5419H74.1873V44.7438Z"
      fill="black"
    />
    <path
      d="M76.6293 46.3693V45.5419H77.4421V41.4962H76.6293V40.6651H78.2695V45.5419H79.0823V46.3693H76.6293V46.3693Z"
      fill="black"
    />
    <path
      d="M83.9626 45.5565V46.3693H81.5096V45.5419H83.948V44.7438H82.3224V43.9273H81.5096V43.1035L82.3224 43.0999V42.2871H84.7791V43.1182H82.337V43.9127H83.9626V44.7291H84.7791V45.5565H83.9626V45.5565Z"
      fill="black"
    />
    <path
      d="M88.8285 46.3693V43.1218H87.2175V46.3693H86.3901V40.6651H87.2175V42.2907H88.8431V43.1072H89.6596V46.3693H88.8285Z"
      fill="black"
    />
    <path
      d="M98.6038 45.5565V46.3693H96.9636V45.5565H96.1508V44.7291H96.9783V45.5419H98.5892V43.9346H96.9636V43.1218H96.1508V41.4816H96.9636V40.6651H98.6038V41.4816H99.4203V42.309H98.5892V41.4962H96.9783V43.1072H98.6038V43.92H99.4203V45.5565H98.6038Z"
      fill="black"
    />
    <path
      d="M102.657 46.3693V45.5565H101.84V43.1218H101.028V42.2907H101.84V40.6651H102.671V42.2907H104.297V43.1218H102.671V45.5419H104.297V46.3693H102.657Z"
      fill="black"
    />
    <path
      d="M107.552 43.1218V43.9346H106.735V46.3693H105.908V42.2944H106.735V43.1108H107.537V42.2944H109.177V43.1255H107.552V43.1218Z"
      fill="black"
    />
    <path
      d="M111.601 46.3693V45.5565H110.788V43.1072H111.601V42.2907H113.241V43.1072H114.058V44.7474H111.616V45.5419H114.058V46.3693H111.601V46.3693ZM113.23 43.1218H111.619V43.92H113.23V43.1218Z"
      fill="black"
    />
    <path
      d="M116.482 46.3693V45.5565H115.669V43.1072H116.482V42.2907H118.122V43.1072H118.938V44.7474H116.496V45.5419H118.938V46.3693H116.482V46.3693ZM118.111 43.1218H116.5V43.92H118.111V43.1218Z"
      fill="black"
    />
    <path
      d="M122.178 46.3693V45.5565H121.362V43.1218H120.549V42.2907H121.362V40.6651H122.193V42.2907H123.819V43.1218H122.193V45.5419H123.819V46.3693H122.178Z"
      fill="black"
    />
    <path
      d="M49.7852 61.0141V59.3959H47.3615V61.0141H46.5341V59.3812H47.3468V56.9392H48.1596V55.3136H48.9907V56.9392H49.8035V59.3812H50.62V61.0141H49.7852ZM48.9724 56.9355H48.1706V58.5611H48.9724V56.9355Z"
      fill="black"
    />
    <path
      d="M53.0364 61.0142V60.2014H52.2236V56.9356H53.051V60.1867H54.662V56.9356H55.4931V61.0105H53.0364V61.0142Z"
      fill="black"
    />
    <path
      d="M59.5607 60.2014V61.0142H57.1076V60.1867H59.546V59.3886H57.9204V58.5721H57.1076V57.7484L57.9204 57.7447V56.9319H60.3771V57.763H57.9351V58.5575H59.5607V59.3739H60.3771V60.2014H59.5607Z"
      fill="black"
    />
    <path
      d="M63.6136 61.0141V60.2013H62.7972V57.7666H61.9844V56.9355H62.7972V55.31H63.6283V56.9355H65.2538V57.7666H63.6283V60.1867H65.2538V61.0141H63.6136Z"
      fill="black"
    />
    <path
      d="M66.8685 61.0141V60.1867H67.6813V57.7666H66.8685V56.9355H68.5087V60.1867H69.3215V61.0141H66.8685V61.0141ZM67.6776 56.1374V55.3063H68.5087V56.1374H67.6776Z"
      fill="black"
    />
    <path
      d="M74.1872 61.0142V57.7667H72.5763V61.0142H71.7489V56.9392H74.2019V57.7557H75.0183V61.0178H74.1872V61.0142Z"
      fill="black"
    />
    <path
      d="M78.2695 61.8306V62.6434H77.4384V61.8159H78.2549V61.0105H77.4384V59.3775H79.0823V61.8306H78.2695Z"
      fill="black "
    />
    <path
      d="M88.0303 56.1374V61.0105H87.1992V56.1374H85.5772V55.3063H89.6558V56.1374H88.0303Z"
      fill="black"
    />
    <path
      d="M93.7089 61.0141V58.5758H92.0979V61.0141H91.2705V58.5538H92.0833V56.9355H91.2705V55.31H92.0979V56.9355H93.7089V55.31H94.54V56.9355H93.7235V58.5538H94.54V61.0141H93.7089Z"
      fill="black"
    />
    <path
      d="M103.484 56.9355V59.3849H102.671V61.0141H101.84V59.3776H102.657V56.9392H103.47V56.1411H101.031V55.31H104.301V56.9355H103.484V56.9355Z"
      fill="black"
    />
    <path
      d="M108.365 57.7666V58.5648H109.181V60.2013H108.365V61.0141H106.724V60.2013H105.912V58.5648H106.724V57.7666H105.912V56.1264H106.724V55.31H108.365V56.1264H109.181V57.7666H108.365ZM108.35 56.1374H106.739V57.7483H108.35V56.1374ZM108.35 58.5758H106.739V60.183H108.35V58.5758Z"
      fill="black"
    />
    <path
      d="M113.245 56.9355V59.3849H112.432V61.0141H111.601V59.3776H112.418V56.9392H113.23V56.1411H110.792V55.31H114.062V56.9355H113.245V56.9355Z"
      fill="black"
    />
    <path
      d="M118.125 60.2013V61.0141H116.485V60.2013H115.672V56.1264H116.485V55.31H118.125V56.1264H118.942V60.2013H118.125ZM118.111 56.1374H116.5V56.9355H117.316V57.752H118.114V56.1374H118.111ZM118.111 58.5758H117.298V57.763H116.496V60.183H118.107V58.5758H118.111Z"
      fill="black"
    />
    <path
      d="M123.006 60.2013V61.0141H121.366V60.2013H120.553V59.3739H121.38V60.1867H122.991V58.5794H122.178V57.752H122.991V56.1411H121.38V56.9538H120.553V56.1264H121.366V55.31H123.006V56.1264H123.822V57.7666H123.006V58.5648H123.822V60.2013H123.006V60.2013Z"
      fill="black"
    />
    <path
      d="M64.2361 271.183V271.79H63.0059V271.183H62.3982V268.125H63.0059V267.514H64.2361V268.125H64.8475V268.744H64.2251V268.136H63.0169V271.172H64.2251V270.564H64.8475V271.183H64.2361Z"
      fill="black"
    />
    <path
      d="M66.6634 271.79V271.183H66.0557V268.733H66.6744V271.172H67.8826V268.733H68.505V271.79H66.6634Z"
      fill="black"
    />
    <path
      d="M71.5549 271.183V271.79H69.717V271.172H71.5476V270.575H70.3284V269.963H69.7206V269.348L70.3284 269.345V268.733H72.17V269.356H70.3394V269.952H71.5586V270.564H72.17V271.183H71.5549Z"
      fill="black"
    />
    <path
      d="M74.5973 271.79V271.183H73.9859V269.356H73.3781V268.733H73.9859V267.514H74.6083V268.733H75.8275V269.356H74.6083V271.172H75.8275V271.79H74.5973V271.79Z"
      fill="black"
    />
    <path
      d="M78.8773 271.183V271.79H77.6472V271.183H77.0394V269.345H77.6472V268.733H78.8773V269.345H79.4888V271.183H78.8773V271.183ZM78.8664 269.356H77.6582V271.172H78.8664V269.356Z"
      fill="black"
    />
    <path
      d="M82.5239 271.79V269.356H81.9271V271.79H81.3047V269.356H80.7079V271.79H80.0892V268.733H82.5385V269.345H83.1499V271.79H82.5239V271.79Z"
      fill="black"
    />
    <path
      d="M84.966 271.79V271.183H84.3582V269.345H84.966V268.733H86.1961V269.345H86.8076V270.575H84.9769V271.172H86.8076V271.79H84.966ZM86.1852 269.356H84.9769V269.952H86.1852V269.356Z"
      fill="black"
    />
    <path
      d="M89.2495 269.356V269.963H88.6381V271.79H88.0194V268.733H88.6381V269.345H89.2386V268.733H90.4687V269.356H89.2495Z"
      fill="black"
    />
    <path
      d="M97.1761 271.183V271.79H95.9459V271.183H95.3381V268.125H95.9459V267.514H97.1761V268.125H97.7875V268.744H97.1651V268.136H95.9569V271.172H97.1651V270.564H97.7875V271.183H97.1761Z"
      fill="black"
    />
    <path
      d="M100.837 271.183V271.79H99.6071V271.183H98.9993V269.345H99.6071V268.733H100.837V269.345H101.449V271.183H100.837V271.183ZM100.826 269.356H99.618V271.172H100.826V269.356Z"
      fill="black"
    />
    <path
      d="M104.499 271.183V271.79H103.279V273.013H102.661V268.733H104.499V269.345H105.11V271.183H104.499V271.183ZM104.488 269.356H103.279V271.172H104.488V269.356Z"
      fill="black"
    />
    <path
      d="M108.16 270.578V271.794H107.552V273.017H106.93V271.794H107.541V271.186H106.93V270.578H106.322V268.733H106.94V270.564H108.149V268.733H108.771V270.575H108.16V270.578Z"
      fill="black"
    />
    <path
      d="M148.825 89.8023H101.979V97.9229H148.825V89.8023Z"
      fill="#F8A2FF"
      className={styles.background}
      style={{
        transformOrigin: '101.97899627685547px 93.86259841918945px',
        transitionDelay: '500ms'
      }}
    />
    <path
      d="M145 145H125V153H145V145Z"
      fill="rgba(148, 60, 255, 0.3)"
      className={styles.background}
      style={{ transformOrigin: '125px 149px', transitionDelay: '750ms' }}
    />
    <path
      d="M145 156H125V164H145V156Z"
      fill="rgba(148, 60, 255, 0.3)"
      className={styles.background}
      style={{ transformOrigin: '125px 160px', transitionDelay: '1000ms' }}
    />
    <path
      d="M149 200H124V208H149V200Z"
      fill="#9BFFCF"
      className={styles.background}
      style={{ transformOrigin: '124px 204px', transitionDelay: '1500ms' }}
    />
    <path
      d="M91 145H44V153H91V145Z"
      fill="#E1FF02"
      className={styles.background}
      style={{ transformOrigin: '44px 149px', transitionDelay: '750ms' }}
    />
    <path
      d="M95 156H44V164H95V156Z"
      fill="#E1FF02"
      className={styles.background}
      style={{ transformOrigin: '44px 160px', transitionDelay: '1000ms' }}
    />
    <path
      d="M22.1393 95.5248V96.1326H20.9092V95.5248H20.3014V94.9061H20.9201V95.5138H22.1283V94.3056H20.9092V93.6979H20.3014V92.4677H20.9092V91.8563H22.1393V92.4677H22.7508V93.0864H22.1283V92.4787H20.9201V93.6869H22.1393V94.2946H22.7508V95.5248H22.1393V95.5248Z"
      fill="black"
    />
    <path
      d="M24.5703 96.1325V95.5248H23.9626V93.6868H24.5703V93.0754H25.8005V93.6868H26.4119V94.917H24.5813V95.5138H26.4119V96.1325H24.5703V96.1325ZM25.7895 93.6978H24.5813V94.2946H25.7895V93.6978Z"
      fill="black"
    />
    <path
      d="M28.854 93.6978V94.3056H28.2426V96.1325H27.6238V93.0754H28.2426V93.6868H28.843V93.0754H30.0732V93.6978H28.854Z"
      fill="black"
    />
    <path
      d="M33.1229 94.917V96.1325H31.8928V94.917H31.285V93.0754H31.9037V94.906H33.112V93.0754H33.7344V94.917H33.1229Z"
      fill="black"
    />
    <path
      d="M35.5504 96.1325V95.5248H34.9426V93.6868H35.5504V93.0754H36.7806V93.6868H37.392V94.917H35.5614V95.5138H37.392V96.1325H35.5504V96.1325ZM36.7732 93.6978H35.565V94.2946H36.7732V93.6978Z"
      fill="black"
    />
    <path
      d="M39.834 93.6978V94.3056H39.2225V96.1325H38.6038V93.0754H39.2225V93.6868H39.823V93.0754H41.0531V93.6978H39.834Z"
      fill="black"
    />
    <path
      d="M42.8728 94.3056V93.0754H44.1029V94.3056H42.8728ZM42.8728 96.1325V94.906H44.1029V96.1325H42.8728Z"
      fill="black "
    />
    <path
      d="M51.4144 96.1326V93.0755H50.8176V94.2946H50.1952V93.0755H49.5985V96.1326H48.9797V91.8563H49.5985V92.4567H50.2062V93.0755L50.8067 93.0645V92.4567H51.4144V91.8563H52.0368V96.1326H51.4144Z"
      fill="black"
    />
    <path
      d="M53.245 96.1326V95.5138H53.8528V93.6979H53.245V93.0755H54.4752V95.5138H55.083V96.1326H53.245ZM53.8528 92.4787V91.8563H54.4752V92.4787H53.8528Z"
      fill="black"
    />
    <path
      d="M58.7441 95.5248V96.1325H57.5139V95.5248H56.9062V93.6868H57.5139V93.0754H58.7441V93.6868H59.3555V94.3056H58.7331V93.6978H57.5249V95.5138H58.7331V94.906H59.3555V95.5248H58.7441Z"
      fill="black"
    />
    <path
      d="M62.3944 96.1326V93.6979H61.1862V96.1326H60.5675V91.8563H61.1862V93.0755H62.4054V93.6869H63.0168V96.1326H62.3944Z"
      fill="black"
    />
    <path
      d="M64.8327 96.1325V95.5248H64.225V94.906H64.8327V94.2946H66.0519V93.6978H64.8327V93.0754H66.0629V93.6868H66.6743V96.1325H64.8327V96.1325ZM66.0556 94.917H64.8474V95.5138H66.0556V94.917Z"
      fill="black"
    />
    <path
      d="M68.494 96.1325V95.5248H67.8863V93.6868H68.494V93.0754H69.7242V93.6868H70.3356V94.917H68.505V95.5138H70.3356V96.1325H68.494V96.1325ZM69.7132 93.6978H68.505V94.2946H69.7132V93.6978Z"
      fill="black"
    />
    <path
      d="M71.5474 96.1326V95.5138H72.1552V92.4787H71.5474V91.8563H72.7776V95.5138H73.3854V96.1326H71.5474Z"
      fill="black "
    />
    <path
      d="M106.318 96.1326V93.0755H105.721V94.2946H105.099V93.0755H104.502V96.1326H103.883V91.8563H104.502V92.4567H105.11V93.0755L105.71 93.0645V92.4567H106.318V91.8563H106.94V96.1326H106.318Z"
      fill="black"
    />
    <path
      d="M108.756 96.1325V95.5248H108.149V94.906H108.756V94.2946H109.976V93.6978H108.756V93.0754H109.987V93.6868H110.598V96.1325H108.756V96.1325ZM109.979 94.917H108.771V95.5138H109.979V94.917Z"
      fill="black"
    />
    <path
      d="M113.648 94.917V96.1325H113.04V97.3554H112.418V96.1325H113.029V95.5248H112.418V94.917H111.81V93.0754H112.429V94.906H113.637V93.0754H114.259V94.917H113.648V94.917Z"
      fill="black"
    />
    <path
      d="M119.129 96.1326V94.9061H119.736V94.2946H120.348V93.6869H120.956V92.4787H119.747V93.0864H119.129V92.4677H119.736V91.8563H120.967V92.4677H121.578V93.6979H120.967V94.3056H120.359V94.917H119.747V95.5138H121.578V96.1326H119.129Z"
      fill="black"
    />
    <path
      d="M122.79 96.1326V94.9061H123.398V94.2946H124.009V93.6869H124.617V92.4787H123.409V93.0864H122.79V92.4677H123.398V91.8563H124.628V92.4677H125.239V93.6979H124.628V94.3056H124.02V94.917H123.409V95.5138H125.239V96.1326H122.79Z"
      fill="black"
    />
    <path
      d="M127.681 96.7476V97.3554H127.059V96.7366H127.67V96.1325H127.059V94.906H128.289V96.7476H127.681Z"
      fill="black"
    />
    <path
      d="M133.77 96.1326V94.9061H134.378V94.2946H134.989V93.6869H135.597V92.4787H134.389V93.0864H133.77V92.4677H134.378V91.8563H135.608V92.4677H136.219V93.6979H135.608V94.3056H135V94.917H134.389V95.5138H136.219V96.1326H133.77Z"
      fill="black"
    />
    <path
      d="M139.273 95.5248V96.1326H138.042V95.5248H137.435V92.4677H138.042V91.8563H139.273V92.4677H139.884V95.5248H139.273ZM139.262 92.4787H138.053V93.0755H138.665V93.6869H139.262V92.4787ZM139.262 94.3056H138.654V93.6979H138.053V95.5138H139.262V94.3056Z"
      fill="black"
    />
    <path
      d="M141.092 96.1326V95.5138H141.7V93.0864H141.092V92.4677H141.7V91.8563H142.322V95.5138H142.93V96.1326H141.092Z"
      fill="black"
    />
    <path
      d="M146.591 95.5248V96.1326H145.361V95.5248H144.753V94.9061H145.372V95.5138H146.58V94.3056H145.361V93.6979H144.753V92.4677H145.361V91.8563H146.591V92.4677H147.203V95.5248H146.591ZM145.372 92.4787V93.6869H146.58V92.4787H145.372Z"
      fill="black"
    />
    <path
      d="M106.329 104.682V105.278H106.94V106.508H106.329V107.116H105.099V106.508H104.491V105.278H105.099V104.682H104.491V103.451H105.099V102.84H106.329V103.451H106.94V104.682H106.329ZM106.318 103.462H105.11V104.671H106.318V103.462ZM106.318 105.289H105.11V106.497H106.318V105.289Z"
      fill="black"
    />
    <path
      d="M108.756 105.289V104.059H109.987V105.289H108.756ZM108.756 107.116V105.89H109.987V107.116H108.756Z"
      fill="black "
    />
    <path
      d="M113.648 105.901V107.116H113.029V105.901H111.198V104.671H111.806V104.059H112.414V103.44H113.025V102.84H113.644V105.278H114.256V105.901H113.648ZM112.429 104.059V104.682H111.821V105.278H113.029V104.059H112.429Z"
      fill="black"
    />
    <path
      d="M117.309 106.508V107.116H116.079V106.508H115.471V103.451H116.079V102.84H117.309V103.451H117.92V104.07H117.298V103.462H116.09V104.671H117.309V105.278H117.92V106.508H117.309ZM117.298 105.289H116.09V106.497H117.298V105.289Z"
      fill="black"
    />
    <path
      d="M124.62 107.116V105.901H122.801V107.116H122.182V105.89H122.79V104.059H123.398V102.84H124.02V104.059H124.628V105.89H125.239V107.116H124.62ZM124.009 104.059H123.409V105.278H124.009V104.059Z"
      fill="black"
    />
    <path
      d="M128.278 107.116V104.059H127.681V105.278H127.059V104.059H126.462V107.116H125.843V102.84H126.462V103.44H127.07V104.059L127.67 104.048V103.44H128.278V102.84H128.9V107.116H128.278Z"
      fill="black"
    />
    <path
      d="M22.1393 128.476V129.699H21.5206V129.084H20.9092V128.476H20.3014V125.419H20.9092V124.807H22.1393V125.419H22.7508V128.476H22.1393V128.476ZM22.1283 125.43H20.9201V128.465H22.1283V125.43Z"
      fill="black"
    />
    <path
      d="M25.1928 125.43V129.084H24.5704V125.43H23.3512V124.807H26.412V125.43H25.1928Z"
      fill="black"
    />
    <path
      d="M29.4617 126.026V126.638H28.854V129.084H28.2316V126.638H27.6238V126.026H27.016V124.807H27.6348V126.026H28.2425V126.627H28.843V126.026H29.4507V124.807H30.0731V126.026H29.4617Z"
      fill="black"
    />
    <path
      d="M48.5001 128.476V129.084H46.6622V124.807H48.5001V125.419H49.1116V128.476H48.5001V128.476ZM48.4892 125.43H47.2809V128.465H48.4892V125.43Z"
      fill="black"
    />
    <path
      d="M50.9421 125.43V126.638H52.1613V127.257H50.9421V128.465H52.7727V129.084H50.3234V124.807H52.7727V125.43H50.9421Z"
      fill="black"
    />
    <path
      d="M55.8225 128.476V129.084H54.5923V128.476H53.9845V127.857H54.6033V128.465H55.8115V127.257H54.5923V126.649H53.9845V125.419H54.5923V124.807H55.8225V125.419H56.4339V126.037H55.8115V125.43H54.6033V126.638H55.8225V127.246H56.4339V128.476H55.8225Z"
      fill="black"
    />
    <path
      d="M59.4837 128.476V129.084H58.2536V128.476H57.6458V125.419H58.2536V124.807H59.4837V125.419H60.0952V126.037H59.4728V125.43H58.2645V128.465H59.4728V127.857H60.0952V128.476H59.4837V128.476Z"
      fill="black"
    />
    <path
      d="M127.571 129.084V127.868H125.752V129.084H125.133V127.857H125.741V126.026H126.349V124.807H126.971V126.026H127.579V127.857H128.19V129.084H127.571ZM126.964 126.026H126.363V127.246H126.964V126.026Z"
      fill="black"
    />
    <path
      d="M131.233 129.084V126.026H130.636V127.246H130.013V126.026H129.417V129.084H128.798V124.807H129.417V125.408H130.024V126.026L130.625 126.015V125.408H131.233V124.807H131.855V129.084H131.233Z"
      fill="black"
    />
    <path
      d="M134.297 125.43V129.084H133.675V125.43H132.455V124.807H135.516V125.43H134.297Z"
      fill="black"
    />
    <path d="M20.9091 140.067V138.841H22.1393V140.067H20.9091Z" fill="black" />
    <path d="M24.5704 140.067V138.841H25.8005V140.067H24.5704Z" fill="black" />
    <path d="M28.2315 140.067V138.841H29.4617V140.067H28.2315Z" fill="black" />
    <path d="M31.8928 140.067V138.841H33.123V140.067H31.8928Z" fill="black" />
    <path d="M35.5503 140.067V138.841H36.7805V140.067H35.5503Z" fill="black" />
    <path d="M39.2116 140.067V138.841H40.4418V140.067H39.2116Z" fill="black" />
    <path d="M42.8728 140.067V138.841H44.1029V140.067H42.8728Z" fill="black" />
    <path d="M46.534 140.067V138.841H47.7642V140.067H46.534Z" fill="black" />
    <path d="M50.1916 140.067V138.841H51.4217V140.067H50.1916Z" fill="black" />
    <path d="M53.8527 140.067V138.841H55.0829V140.067H53.8527Z" fill="black" />
    <path d="M57.514 140.067V138.841H58.7442V140.067H57.514Z" fill="black" />
    <path d="M61.1752 140.067V138.841H62.4053V140.067H61.1752Z" fill="black" />
    <path d="M64.8328 140.067V138.841H66.063V140.067H64.8328Z" fill="black" />
    <path d="M68.494 140.067V138.841H69.7241V140.067H68.494Z" fill="black" />
    <path d="M72.1553 140.067V138.841H73.3854V140.067H72.1553Z" fill="black" />
    <path d="M75.8164 140.067V138.841H77.0466V140.067H75.8164Z" fill="black" />
    <path d="M79.4739 140.067V138.841H80.7041V140.067H79.4739Z" fill="black" />
    <path d="M83.1352 140.067V138.841H84.3654V140.067H83.1352Z" fill="black" />
    <path d="M86.7964 140.067V138.841H88.0265V140.067H86.7964Z" fill="black" />
    <path d="M90.4576 140.067V138.841H91.6878V140.067H90.4576Z" fill="black" />
    <path d="M94.1151 140.067V138.841H95.3453V140.067H94.1151Z" fill="black" />
    <path d="M97.7764 140.067V138.841H99.0066V140.067H97.7764Z" fill="black" />
    <path d="M101.438 140.067V138.841H102.668V140.067H101.438Z" fill="black" />
    <path d="M105.099 140.067V138.841H106.329V140.067H105.099Z" fill="black" />
    <path d="M108.756 140.067V138.841H109.987V140.067H108.756Z" fill="black" />
    <path d="M112.418 140.067V138.841H113.648V140.067H112.418Z" fill="black" />
    <path d="M116.079 140.067V138.841H117.309V140.067H116.079Z" fill="black" />
    <path d="M119.74 140.067V138.841H120.97V140.067H119.74Z" fill="black" />
    <path d="M123.398 140.067V138.841H124.628V140.067H123.398Z" fill="black" />
    <path d="M127.059 140.067V138.841H128.289V140.067H127.059Z" fill="black" />
    <path d="M130.72 140.067V138.841H131.95V140.067H130.72Z" fill="black" />
    <path d="M134.381 140.067V138.841H135.611V140.067H134.381Z" fill="black" />
    <path d="M138.039 140.067V138.841H139.269V140.067H138.039Z" fill="black" />
    <path d="M141.7 140.067V138.841H142.93V140.067H141.7Z" fill="black" />
    <path d="M145.361 140.067V138.841H146.591V140.067H145.361Z" fill="black" />
    <path d="M149.022 140.067V138.841H150.253V140.067H149.022Z" fill="black" />
    <path
      d="M20.3014 151.051V150.432H20.9092V148.005H20.3014V147.386H20.9092V146.774H21.5316V150.432H22.1393V151.051H20.3014Z"
      fill="black"
    />
    <path
      d="M47.7642 150.443V151.051H46.534V150.443H45.9262V147.386H46.534V146.774H47.7642V147.386H48.3756V148.005H47.7532V147.397H46.545V150.432H47.7532V149.835H47.1454V149.213H48.3756V150.443H47.7642Z"
      fill="black"
    />
    <path
      d="M50.814 148.616V149.224H50.2026V151.051H49.5839V147.994H50.2026V148.605H50.803V147.994H52.0332V148.616H50.814Z"
      fill="black"
    />
    <path
      d="M53.8528 151.051V150.443H53.245V149.824H53.8528V149.213H55.072V148.616H53.8528V147.994H55.083V148.605H55.6944V151.051H53.8528ZM55.072 149.835H53.8638V150.432H55.072V149.835Z"
      fill="black"
    />
    <path
      d="M58.7331 151.051V148.616H57.5249V151.051H56.9062V147.994H58.7441V148.605H59.3555V151.051H58.7331Z"
      fill="black "
    />
    <path
      d="M62.4054 150.443V151.051H61.1752V150.443H60.5675V148.605H61.1752V147.994H62.4054V148.605H63.0168V150.443H62.4054ZM62.3944 148.616H61.1862V150.432H62.3944V148.616Z"
      fill="black"
    />
    <path
      d="M64.225 151.051V150.432H64.8327V147.397H64.225V146.774H65.4551V150.432H66.0629V151.051H64.225Z"
      fill="black"
    />
    <path
      d="M68.494 151.051V150.443H67.8863V149.824H68.494V149.213H69.7132V148.616H68.494V147.994H69.7242V148.605H70.3356V151.051H68.494ZM69.7132 149.835H68.505V150.432H69.7132V149.835Z"
      fill="black"
    />
    <path
      d="M77.0466 150.443V151.051H75.2087V146.774H77.0466V147.386H77.6581V148.616H77.0466V149.213H77.6581V150.443H77.0466V150.443ZM77.0357 147.397H75.8275V148.605H77.0357V147.397ZM77.0357 149.224H75.8275V150.432H77.0357V149.224Z"
      fill="black"
    />
    <path
      d="M80.7078 150.443V151.051H79.4776V150.443H78.8699V148.605H79.4776V147.994H80.7078V148.605H81.3192V150.443H80.7078ZM80.6968 148.616H79.4886V150.432H80.6968V148.616Z"
      fill="black"
    />
    <path
      d="M84.3653 149.835V151.051H83.7466V149.832H83.1461V151.051H82.5274V149.835H81.9196V147.994H82.5384V149.824H83.1351V148.605H83.7576V149.824H84.3543V147.994H84.9767V149.835H84.3653Z"
      fill="black"
    />
    <path
      d="M86.1887 151.051V150.432H86.7964V147.397H86.1887V146.774H87.4188V150.432H88.0266V151.051H86.1887Z"
      fill="black "
    />
    <path
      d="M128.289 150.443V151.051H127.681V151.666H127.059V150.443H126.451V149.824H127.07V150.432H128.278V149.224H127.059V148.616H126.451V147.386H127.059V146.774H127.67V146.167H128.289V147.386H128.9V148.005H128.278V147.397H127.07V148.605H128.289V149.213H128.9V150.443H128.289Z"
      fill="black"
    />
    <path
      d="M131.95 150.443V151.051H130.72V150.443H130.112V149.824H130.731V150.432H131.939V149.224H130.72V148.616H130.112V147.386H130.72V146.774H131.95V147.386H132.562V150.443H131.95ZM130.731 147.397V148.605H131.939V147.397H130.731Z"
      fill="black"
    />
    <path d="M134.381 151.051V149.824H135.611V151.051H134.381Z" fill="black" />
    <path
      d="M139.273 150.443V151.051H138.042V150.443H137.435V147.386H138.042V146.774H139.273V147.386H139.884V150.443H139.273ZM139.262 147.397H138.053V147.994H138.665V148.605H139.262V147.397ZM139.262 149.224H138.654V148.616H138.053V150.432H139.262V149.224Z"
      fill="black"
    />
    <path
      d="M142.93 150.443V151.051H141.7V150.443H141.092V147.386H141.7V146.774H142.93V147.386H143.542V150.443H142.93ZM142.919 147.397H141.711V147.994H142.322V148.605H142.919V147.397ZM142.919 149.224H142.311V148.616H141.711V150.432H142.919V149.224Z"
      fill="black"
    />
    <path
      d="M20.3014 162.034V161.416H20.9092V158.988H20.3014V158.37H20.9092V157.758H21.5316V161.416H22.1393V162.034H20.3014Z"
      fill="black"
    />
    <path
      d="M47.7642 159.6V161.427H47.1565V162.034H46.5341V161.427H45.9263V159.6H45.3185V157.758H45.9373V159.589H46.545V161.416H47.1455V159.589H47.7532V157.758H48.3757V159.6H47.7642Z"
      fill="black"
    />
    <path
      d="M50.1916 162.034V161.427H49.5839V160.808H50.1916V160.196H51.4108V159.6H50.1916V158.977H51.4218V159.589H52.0332V162.034H50.1916ZM51.4145 160.819H50.2063V161.416H51.4145V160.819Z"
      fill="black"
    />
    <path
      d="M55.072 162.034V159.6H53.8638V162.034H53.245V158.977H55.083V159.589H55.6944V162.034H55.072Z"
      fill="black"
    />
    <path
      d="M56.9062 162.034V161.416H57.5139V159.6H56.9062V158.977H58.1364V161.416H58.7441V162.034H56.9062V162.034ZM57.5139 158.381V157.758H58.1364V158.381H57.5139Z"
      fill="black"
    />
    <path
      d="M60.5638 162.034V161.416H61.1716V158.381H60.5638V157.758H61.794V161.416H62.4017V162.034H60.5638Z"
      fill="black"
    />
    <path
      d="M64.225 162.034V161.416H64.8327V158.381H64.225V157.758H65.4551V161.416H66.0629V162.034H64.225Z"
      fill="black"
    />
    <path
      d="M68.494 162.034V161.427H67.8863V160.808H68.494V160.196H69.7132V159.6H68.494V158.977H69.7242V159.589H70.3356V162.034H68.494ZM69.7132 160.819H68.505V161.416H69.7132V160.819Z"
      fill="black"
    />
    <path d="M75.2051 162.034V157.758H75.8238V161.416H77.6544V162.034H75.2051Z" fill="black" />
    <path
      d="M79.474 162.034V161.427H78.8662V160.808H79.474V160.196H80.6932V159.6H79.474V158.977H80.7041V159.589H81.3156V162.034H79.474ZM80.6968 160.819H79.4886V161.416H80.6968V160.819Z"
      fill="black"
    />
    <path
      d="M83.7466 162.034V161.427H83.1351V159.6H82.5274V158.977H83.1351V157.758H83.7575V158.977H84.9767V159.6H83.7575V161.416H84.9767V162.034H83.7466V162.034Z"
      fill="black"
    />
    <path
      d="M87.4078 162.034V161.427H86.7964V159.6H86.1887V158.977H86.7964V157.758H87.4188V158.977H88.638V159.6H87.4188V161.416H88.638V162.034H87.4078V162.034Z"
      fill="black"
    />
    <path
      d="M90.4576 162.034V161.427H89.8498V159.589H90.4576V158.977H91.6878V159.589H92.2992V160.819H90.4686V161.416H92.2992V162.034H90.4576ZM91.6768 159.6H90.4686V160.196H91.6768V159.6Z"
      fill="black"
    />
    <path
      d="M128.289 161.427V162.034H127.681V162.649H127.059V161.427H126.451V160.808H127.07V161.416H128.278V160.207H127.059V159.6H126.451V158.37H127.059V157.758H127.67V157.15H128.289V158.37H128.9V158.988H128.278V158.38H127.07V159.589H128.289V160.196H128.9V161.427H128.289Z"
      fill="black"
    />
    <path
      d="M131.95 161.427V162.034H130.72V161.427H130.112V160.808H130.731V161.416H131.939V159.6H130.109V157.758H132.558V158.381H130.727V158.977H131.947V159.589H132.558V161.427H131.95V161.427Z"
      fill="black"
    />
    <path d="M134.381 162.034V160.808H135.611V162.034H134.381Z" fill="black" />
    <path
      d="M139.273 161.427V162.034H138.042V161.427H137.435V158.37H138.042V157.758H139.273V158.37H139.884V161.427H139.273ZM139.262 158.381H138.053V158.977H138.665V159.589H139.262V158.381ZM139.262 160.207H138.654V159.6H138.053V161.416H139.262V160.207Z"
      fill="black"
    />
    <path
      d="M142.93 161.427V162.034H141.7V161.427H141.092V158.37H141.7V157.758H142.93V158.37H143.542V161.427H142.93ZM142.919 158.381H141.711V158.977H142.322V159.589H142.919V158.381ZM142.919 160.207H142.311V159.6H141.711V161.416H142.919V160.207Z"
      fill="black"
    />
    <path
      d="M47.7642 183.394V184.002H46.534V183.394H45.9262V182.775H46.545V183.383H47.7532V182.175H46.534V181.567H45.9262V180.337H46.534V179.725H47.7642V180.337H48.3756V180.956H47.7532V180.348H46.545V181.556H47.7642V182.164H48.3756V183.394H47.7642Z"
      fill="black"
    />
    <path
      d="M51.4218 183.394V184.002H50.1916V183.394H49.5839V179.725H50.2026V183.383H51.4108V179.725H52.0332V183.394H51.4218Z"
      fill="black"
    />
    <path
      d="M55.083 183.394V184.002H53.245V179.725H55.083V180.337H55.6944V181.567H55.083V182.164H55.6944V183.394H55.083V183.394ZM55.072 180.348H53.8638V181.556H55.072V180.348ZM55.072 182.175H53.8638V183.383H55.072V182.175Z"
      fill="black"
    />
    <path
      d="M58.1364 180.348V184.002H57.514V180.348H56.2948V179.725H59.3555V180.348H58.1364Z"
      fill="black"
    />
    <path
      d="M62.4054 183.394V184.002H61.1752V183.394H60.5675V180.337H61.1752V179.725H62.4054V180.337H63.0168V183.394H62.4054ZM62.3944 180.348H61.1862V183.383H62.3944V180.348Z"
      fill="black"
    />
    <path
      d="M65.4552 180.348V184.002H64.8328V180.348H63.6136V179.725H66.6743V180.348H65.4552Z"
      fill="black"
    />
    <path
      d="M69.7131 184.002V182.786H67.8935V184.002H67.2747V182.775H67.8825V180.945H68.4903V179.725H69.1127V180.945H69.7204V182.775H70.3319V184.002H69.7131ZM69.1053 180.945H68.5049V182.164H69.1053V180.945Z"
      fill="black"
    />
    <path d="M71.5474 184.002V179.725H72.1662V183.383H73.9968V184.002H71.5474Z" fill="black" />
    <path
      d="M128.289 183.394V184.002H127.681V184.617H127.059V183.394H126.451V182.775H127.07V183.383H128.278V182.175H127.059V181.567H126.451V180.337H127.059V179.725H127.67V179.118H128.289V180.337H128.9V180.956H128.278V180.348H127.07V181.556H128.289V182.164H128.9V183.394H128.289Z"
      fill="black"
    />
    <path
      d="M130.112 184.002V183.383H130.72V180.956H130.112V180.337H130.72V179.725H131.342V183.383H131.95V184.002H130.112Z"
      fill="black"
    />
    <path
      d="M135.611 182.786V184.002H134.993V182.786H133.162V181.556H133.77V180.945H134.377V180.326H134.989V179.725H135.608V182.164H136.219V182.786H135.611ZM134.392 180.945V181.567H133.784V182.164H134.993V180.945H134.392Z"
      fill="black"
    />
    <path d="M138.039 184.002V182.775H139.269V184.002H138.039Z" fill="black" />
    <path
      d="M142.93 183.394V184.002H141.7V183.394H141.092V180.337H141.7V179.725H142.93V180.337H143.542V183.394H142.93ZM142.919 180.348H141.711V180.945H142.322V181.556H142.919V180.348ZM142.919 182.175H142.311V181.567H141.711V183.383H142.919V182.175Z"
      fill="black"
    />
    <path
      d="M146.591 183.394V184.002H145.361V183.394H144.753V180.337H145.361V179.725H146.591V180.337H147.203V183.394H146.591ZM146.58 180.348H145.372V180.945H145.984V181.556H146.58V180.348ZM146.58 182.175H145.973V181.567H145.372V183.383H146.58V182.175Z"
      fill="black"
    />
    <path
      d="M47.1528 191.332V194.985H46.5304V191.332H45.3112V190.709H48.3719V191.332H47.1528Z"
      fill="black"
    />
    <path
      d="M51.4144 194.985V193.77H49.5947V194.985H48.976V193.759H49.5838V191.928H50.1915V190.709H50.8139V191.928H51.4217V193.759H52.0331V194.985H51.4144ZM50.8029 191.928H50.2025V193.147H50.8029V191.928Z"
      fill="black"
    />
    <path
      d="M55.072 194.985V193.155H53.8638V194.985H53.245V193.14H53.8528V191.928H53.245V190.709H53.8638V191.928H55.072V190.709H55.6944V191.928H55.083V193.14H55.6944V194.985H55.072Z"
      fill="black"
    />
    <path
      d="M62.4054 192.551V193.147H63.0168V194.378H62.4054V194.985H61.1752V194.378H60.5675V193.147H61.1752V192.551H60.5675V191.321H61.1752V190.709H62.4054V191.321H63.0168V192.551H62.4054ZM62.3944 191.332H61.1862V192.54H62.3944V191.332ZM62.3944 193.158H61.1862V194.367H62.3944V193.158Z"
      fill="black"
    />
    <path d="M64.8328 194.985V193.759H66.063V194.985H64.8328Z" fill="black" />
    <path
      d="M67.8863 194.985V193.759H68.494V193.147H69.1055V192.54H69.7132V191.332H68.505V191.939H67.8863V191.321H68.494V190.709H69.7242V191.321H70.3356V192.551H69.7242V193.158H69.1164V193.77H68.505V194.367H70.3356V194.985H67.8863Z"
      fill="black"
    />
    <path
      d="M73.3854 194.378V194.985H72.1552V194.378H71.5474V193.759H72.1662V194.367H73.3744V192.551H71.5438V190.709H73.9931V191.332H72.1625V191.928H73.3817V192.54H73.9931V194.378H73.3854V194.378Z"
      fill="black"
    />
    <path
      d="M74.5972 191.939V190.709H75.8237V191.939H74.5972ZM76.4351 192.551V193.158H75.8237V194.378H75.2159V194.985H74.5972V194.367H75.2049V193.147H75.8127V192.54H76.4241V191.321H77.0429V192.551H76.4351V192.551ZM76.4278 194.985V193.759H77.658V194.985H76.4278ZM77.0355 191.332V190.709H77.658V191.332H77.0355Z"
      fill="black"
    />
    <path
      d="M128.289 194.378V194.985H127.681V195.6H127.059V194.378H126.451V193.759H127.07V194.367H128.278V193.158H127.059V192.551H126.451V191.32H127.059V190.709H127.67V190.101H128.289V191.32H128.9V191.939H128.278V191.331H127.07V192.54H128.289V193.147H128.9V194.378H128.289Z"
      fill="black"
    />
    <path
      d="M130.112 194.985V194.367H130.72V191.939H130.112V191.321H130.72V190.709H131.342V194.367H131.95V194.985H130.112Z"
      fill="black"
    />
    <path d="M134.381 194.985V193.759H135.611V194.985H134.381Z" fill="black" />
    <path
      d="M137.431 194.985V194.367H138.039V191.939H137.431V191.321H138.039V190.709H138.661V194.367H139.269V194.985H137.431Z"
      fill="black"
    />
    <path
      d="M142.93 194.378V194.985H141.7V194.378H141.092V193.759H141.711V194.367H142.919V192.551H141.089V190.709H143.538V191.332H141.707V191.928H142.926V192.54H143.538V194.378H142.93V194.378Z"
      fill="black"
    />
    <path
      d="M47.1528 202.315V205.969H46.5304V202.315H45.3112V201.693H48.3719V202.315H47.1528Z"
      fill="black"
    />
    <path
      d="M51.4218 205.361V205.969H50.1916V205.361H49.5839V202.304H50.1916V201.693H51.4218V202.304H52.0332V205.361H51.4218ZM51.4145 202.315H50.2063V205.35H51.4145V202.315Z"
      fill="black"
    />
    <path
      d="M54.4752 202.315V205.969H53.8528V202.315H52.6336V201.693H55.6944V202.315H54.4752Z"
      fill="black"
    />
    <path
      d="M58.7331 205.969V204.753H56.9135V205.969H56.2948V204.743H56.9025V202.912H57.5103V201.693H58.1327V202.912H58.7405V204.743H59.3519V205.969H58.7331ZM58.1254 202.912H57.5249V204.131H58.1254V202.912Z"
      fill="black"
    />
    <path
      d="M60.5638 205.969V201.693H61.1826V205.35H63.0132V205.969H60.5638V205.969Z"
      fill="black"
    />
    <path
      d="M128.289 205.361V205.969H127.681V206.584H127.059V205.361H126.451V204.742H127.07V205.35H128.278V204.142H127.059V203.534H126.451V202.304H127.059V201.693H127.67V201.085H128.289V202.304H128.9V202.923H128.278V202.315H127.07V203.523H128.289V204.131H128.9V205.361H128.289Z"
      fill="black"
    />
    <path
      d="M130.112 205.969V205.35H130.72V202.923H130.112V202.304H130.72V201.693H131.342V205.35H131.95V205.969H130.112Z"
      fill="black"
    />
    <path
      d="M135.611 205.361V205.969H134.381V205.361H133.774V204.743H134.392V205.35H135.6V203.534H133.77V201.693H136.219V202.315H134.389V202.912H135.608V203.523H136.219V205.361H135.611V205.361Z"
      fill="black"
    />
    <path d="M138.039 205.969V204.743H139.269V205.969H138.039Z" fill="black" />
    <path
      d="M141.092 205.969V205.35H141.7V202.923H141.092V202.304H141.7V201.693H142.322V205.35H142.93V205.969H141.092Z"
      fill="black"
    />
    <path
      d="M146.591 205.361V205.969H145.361V205.361H144.753V204.743H145.372V205.35H146.58V203.534H144.75V201.693H147.199V202.315H145.369V202.912H146.588V203.523H147.199V205.361H146.591V205.361Z"
      fill="black"
    />
    <path d="M20.9091 216.953V215.726H22.1393V216.953H20.9091Z" fill="black" />
    <path d="M24.5704 216.953V215.726H25.8005V216.953H24.5704Z" fill="black" />
    <path d="M28.2315 216.953V215.726H29.4617V216.953H28.2315Z" fill="black" />
    <path d="M31.8928 216.953V215.726H33.123V216.953H31.8928Z" fill="black" />
    <path d="M35.5503 216.953V215.726H36.7805V216.953H35.5503Z" fill="black" />
    <path d="M39.2116 216.953V215.726H40.4418V216.953H39.2116Z" fill="black" />
    <path d="M42.8728 216.953V215.726H44.1029V216.953H42.8728Z" fill="black" />
    <path d="M46.534 216.953V215.726H47.7642V216.953H46.534Z" fill="black" />
    <path d="M50.1916 216.953V215.726H51.4217V216.953H50.1916Z" fill="black" />
    <path d="M53.8527 216.953V215.726H55.0829V216.953H53.8527Z" fill="black" />
    <path d="M57.514 216.953V215.726H58.7442V216.953H57.514Z" fill="black" />
    <path d="M61.1752 216.953V215.726H62.4053V216.953H61.1752Z" fill="black" />
    <path d="M64.8328 216.953V215.726H66.063V216.953H64.8328Z" fill="black" />
    <path d="M68.494 216.953V215.726H69.7241V216.953H68.494Z" fill="black" />
    <path d="M72.1553 216.953V215.726H73.3854V216.953H72.1553Z" fill="black" />
    <path d="M75.8164 216.953V215.726H77.0466V216.953H75.8164Z" fill="black" />
    <path d="M79.4739 216.953V215.726H80.7041V216.953H79.4739Z" fill="black" />
    <path d="M83.1352 216.953V215.726H84.3654V216.953H83.1352Z" fill="black" />
    <path d="M86.7964 216.953V215.726H88.0265V216.953H86.7964Z" fill="black" />
    <path d="M90.4576 216.953V215.726H91.6878V216.953H90.4576Z" fill="black" />
    <path d="M94.1151 216.953V215.726H95.3453V216.953H94.1151Z" fill="black" />
    <path d="M97.7764 216.953V215.726H99.0066V216.953H97.7764Z" fill="black" />
    <path d="M101.438 216.953V215.726H102.668V216.953H101.438Z" fill="black" />
    <path d="M105.099 216.953V215.726H106.329V216.953H105.099Z" fill="black" />
    <path d="M108.756 216.953V215.726H109.987V216.953H108.756Z" fill="black" />
    <path d="M112.418 216.953V215.726H113.648V216.953H112.418Z" fill="black" />
    <path d="M116.079 216.953V215.726H117.309V216.953H116.079Z" fill="black" />
    <path d="M119.74 216.953V215.726H120.97V216.953H119.74Z" fill="black" />
    <path d="M123.398 216.953V215.726H124.628V216.953H123.398Z" fill="black" />
    <path d="M127.059 216.953V215.726H128.289V216.953H127.059Z" fill="black" />
    <path d="M130.72 216.953V215.726H131.95V216.953H130.72Z" fill="black" />
    <path d="M134.381 216.953V215.726H135.611V216.953H134.381Z" fill="black" />
    <path d="M138.039 216.953V215.726H139.269V216.953H138.039Z" fill="black" />
    <path d="M141.7 216.953V215.726H142.93V216.953H141.7Z" fill="black" />
    <path d="M145.361 216.953V215.726H146.591V216.953H145.361Z" fill="black" />
    <path d="M149.022 216.953V215.726H150.253V216.953H149.022Z" fill="black" />
    <path
      d="M47.7642 227.329V227.936H46.534V227.329H45.9262V224.271H46.534V223.66H47.7642V224.271H48.3756V224.89H47.7532V224.282H46.545V227.318H47.7532V226.71H48.3756V227.329H47.7642V227.329Z"
      fill="black"
    />
    <path
      d="M51.4144 227.936V226.721H49.5947V227.936H48.976V226.71H49.5838V224.879H50.1915V223.66H50.8139V224.879H51.4217V226.71H52.0331V227.936H51.4144ZM50.8029 224.879H50.2025V226.098H50.8029V224.879Z"
      fill="black"
    />
    <path
      d="M55.083 227.329V227.936H53.8528V227.329H53.245V226.71H53.8638V227.318H55.072V226.109H53.8528V225.502H53.245V224.271H53.8528V223.66H55.083V224.271H55.6944V224.89H55.072V224.282H53.8638V225.491H55.083V226.098H55.6944V227.329H55.083Z"
      fill="black"
    />
    <path
      d="M58.7331 227.936V226.109H57.5249V227.936H56.9062V223.66H57.5249V225.491H58.7331V223.66H59.3555V227.936H58.7331Z"
      fill="black"
    />
    <path
      d="M128.289 227.329V227.936H127.681V228.551H127.059V227.329H126.451V226.71H127.07V227.318H128.278V226.109H127.059V225.502H126.451V224.271H127.059V223.66H127.67V223.052H128.289V224.271H128.9V224.89H128.278V224.282H127.07V225.491H128.289V226.098H128.9V227.329H128.289Z"
      fill="black"
    />
    <path
      d="M130.112 227.936V226.71H130.72V226.098H131.331V225.491H131.939V224.282H130.731V224.89H130.112V224.271H130.72V223.66H131.95V224.271H132.562V225.502H131.95V226.109H131.342V226.721H130.731V227.318H132.562V227.936H130.112Z"
      fill="black"
    />
    <path
      d="M135.611 227.329V227.936H134.381V227.329H133.774V224.271H134.381V223.66H135.611V224.271H136.223V227.329H135.611ZM135.6 224.282H134.392V224.879H135.004V225.491H135.6V224.282ZM135.6 226.109H134.993V225.502H134.392V227.318H135.6V226.109Z"
      fill="black"
    />
    <path d="M138.039 227.936V226.71H139.269V227.936H138.039Z" fill="black" />
    <path
      d="M142.93 227.329V227.936H141.7V227.329H141.092V224.271H141.7V223.66H142.93V224.271H143.542V227.329H142.93ZM142.919 224.282H141.711V224.879H142.322V225.491H142.919V224.282ZM142.919 226.109H142.311V225.502H141.711V227.318H142.919V226.109Z"
      fill="black"
    />
    <path
      d="M146.591 227.329V227.936H145.361V227.329H144.753V224.271H145.361V223.66H146.591V224.271H147.203V227.329H146.591ZM146.58 224.282H145.372V224.879H145.984V225.491H146.58V224.282ZM146.58 226.109H145.973V225.502H145.372V227.318H146.58V226.109Z"
      fill="black"
    />
    <path
      d="M47.7642 238.312V238.92H46.534V238.312H45.9262V235.255H46.534V234.644H47.7642V235.255H48.3756V235.874H47.7532V235.266H46.545V238.301H47.7532V237.693H48.3756V238.312H47.7642V238.312Z"
      fill="black"
    />
    <path
      d="M51.4145 238.92V237.093H50.2063V238.92H49.5875V234.644H50.2063V236.474H51.4145V234.644H52.0369V238.92H51.4145Z"
      fill="black"
    />
    <path
      d="M55.072 238.92V237.704H53.2524V238.92H52.6336V237.693H53.2414V235.863H53.8491V234.644H54.4715V235.863H55.0793V237.693H55.6907V238.92H55.072ZM54.4642 235.863H53.8638V237.082H54.4642V235.863Z"
      fill="black"
    />
    <path
      d="M58.7331 238.92V236.485H58.1254V235.863H57.5249V238.92H56.9062V234.644H57.5249V235.244H58.1364V235.863L58.7331 235.852V234.644H59.3555V238.92H58.7331V238.92Z"
      fill="black"
    />
    <path
      d="M62.4054 238.312V238.92H61.1752V238.312H60.5675V235.255H61.1752V234.644H62.4054V235.255H63.0168V235.874H62.3944V235.266H61.1862V238.301H62.3944V237.704H61.7867V237.082H63.0168V238.312H62.4054Z"
      fill="black"
    />
    <path
      d="M64.8437 235.266V236.474H66.0629V237.093H64.8437V238.301H66.6743V238.92H64.225V234.644H66.6743V235.266H64.8437V235.266Z"
      fill="black"
    />
    <path
      d="M128.289 238.312V238.92H127.681V239.535H127.059V238.312H126.451V237.693H127.07V238.301H128.278V237.093H127.059V236.485H126.451V235.255H127.059V234.644H127.67V234.036H128.289V235.255H128.9V235.874H128.278V235.266H127.07V236.474H128.289V237.082H128.9V238.312H128.289Z"
      fill="black"
    />
    <path
      d="M131.95 237.704V238.92H131.331V237.704H129.501V236.474H130.109V235.863H130.716V235.244H131.328V234.644H131.946V237.082H132.558V237.704H131.95ZM130.731 235.863V236.485H130.123V237.082H131.331V235.863H130.731Z"
      fill="black"
    />
    <path d="M134.381 238.92V237.693H135.611V238.92H134.381Z" fill="black" />
    <path
      d="M139.273 236.485V237.082H139.884V238.312H139.273V238.92H138.042V238.312H137.435V237.082H138.042V236.485H137.435V235.255H138.042V234.644H139.273V235.255H139.884V236.485H139.273ZM139.262 235.266H138.053V236.474H139.262V235.266ZM139.262 237.093H138.053V238.301H139.262V237.093Z"
      fill="black"
    />
    <path
      d="M142.93 238.312V238.92H141.7V238.312H141.092V237.693H141.711V238.301H142.919V236.485H141.089V234.644H143.538V235.266H141.707V235.863H142.926V236.474H143.538V238.312H142.93V238.312Z"
      fill="black"
    />
  </svg>
);

export default Receipt;
